import type { ISampleMetaData } from './ISampleMetaData.js'

export const sampleMetaDataStub: ISampleMetaData[] = [
  {
    id: '',
    version: '',
    sampleId: '',
    orderId: '',
    isShadowed: false,
    customerSampleName: 'Lake Sample 1',
    forwardPrimerRequested: 'GTGCCAGCMGCCGCGGTAA',
    reversePrimerRequested: 'GGACTACHVGGGTWTCTAAT',
    sampleCoordinates: {
      type: 'Point',
      coordinates: [52.736497054, 9.751163662]
    }
  },
  {
    id: '',
    version: '',
    sampleId: '',
    orderId: '',
    isShadowed: false,
    customerSampleName: 'Soil Sample A',
    forwardPrimerRequested: 'CCTACGGGNGGCWGCAG',
    reversePrimerRequested: 'GACTACHVGGGTATCTAATCC',
    sampleCoordinates: {
      type: 'Point',
      coordinates: [52.738497054, 9.753163662]
    }
  },
  {
    id: '',
    version: '',
    sampleId: '',
    orderId: '',
    isShadowed: false,
    customerSampleName: 'Marine Sample X',
    forwardPrimerRequested: 'GTGYCAGCMGCCGCGGTAA',
    reversePrimerRequested: 'GGACTACNVGGGTWTCTAAT',
    sampleCoordinates: {
      type: 'Point',
      coordinates: [52.735497054, 9.750163662]
    }
  },
  {
    id: '',
    version: '',
    sampleId: '',
    orderId: '',
    isShadowed: false,
    customerSampleName: 'Plant Sample 2023'
  },
  {
    id: '',
    version: '',
    sampleId: '',
    orderId: '',
    isShadowed: false,
    customerSampleName: 'Unknown Sample',
    forwardPrimerRequested: 'GTGCCAGCMGCCGCGGTAA',
    reversePrimerRequested: 'GGACTACHVGGGTWTCTAAT'
  }
]
